import React from 'react';
import PauseIcon from '@mui/icons-material/Pause';
import Button from 'pages/Dashboard/components/Button';

type Props = {
  message: string;
  disabled?: boolean;
  onRefresh: () => void;
};

export default function RefreshBanner({
  message,
  disabled = false,
  onRefresh,
}: Props) {
  return (
    <div className="mx-4 mb-4 text-xs flex justify-between items-center gap-2 border border-blue-100 bg-blue-50 rounded-lg px-3 py-2">
      <span className="flex items-center gap-1 text-gray-700 font-semibold">
        <PauseIcon className="!w-4 !h-4" />
        <span>{message}</span>
        <span className="text-gray-500 font-medium">Refresh to load the latest version.</span>
      </span>
      <Button
        variant="contained"
        size="small"
        className="!bg-blue-500 hover:!bg-blue-600 !text-white !px-3 !py-1 !text-xs shrink-0"
        disabled={disabled}
        onClick={onRefresh}
      >
        Refresh
      </Button>
    </div>
  );
}
